// extracted by mini-css-extract-plugin
module.exports = {"button":"Favorite_button_2UVkb","wrapper":"Favorite_wrapper_6i8-I","optional":"Favorite_optional_1TBsB"};